import React, { Component } from 'react'
import removeItemFromArray from '../../functions/removeItemFromArray'
import getOtherFilters from '../../functions/getOtherFilters'
import naturalCompare from '../../functions/naturalCompareStrings'
import getTranslation from '../../functions/getTranslation'
import checkForAttributeMapping from '../../functions/checkForAttributeMapping'
import FilterItem from './FilterItem'
import seperateAttributes from '../../functions/seperateAttributes'
import { MULTICINEMA } from '../../constants/multiCinemaModes'
import config from '../../config.json'
import { useFilterValues } from '../HooksOverview/useFilterValues'

class FilterItemContainer extends Component {
    constructor(props) {
        super(props)
    }

    getItemName() {
        const { filterId, item, translation } = this.props
        let itemName = item.name

        if(filterId === 'fsk') {
            if(item.name === '-1' || item.name === null) {
                itemName = getTranslation('FSKnotKnown', translation)
            } else {
                itemName = getTranslation('fsk', translation) + ' ' + item.name
            }
        } else if(filterId === 'technical') {
            if(item.name.toLowerCase() === 'digital') {
                return ''
            } else {
                itemName = checkForAttributeMapping(item.name, translation)
            }
        }

        return itemName
    }

    getSortValue() {
        const { item, filterValues, otherFilters, filterStringWithEqualSign } = this.props 
        const itemId = item.id

        let sortValue = '?' + filterStringWithEqualSign + itemId
        let className = ''

        if(filterValues) {
            let copyFilterValues = filterValues.slice()
            const currentFilterValuesIndex = copyFilterValues.indexOf(itemId)

            if(-1 === currentFilterValuesIndex) {
                copyFilterValues.push(itemId)
            } else {
                className = ' filter-active'
                copyFilterValues = removeItemFromArray(copyFilterValues, itemId)
            }

            if(0 === copyFilterValues.length) {
                sortValue = null 
            } else {
                sortValue = '?' + filterStringWithEqualSign + copyFilterValues.join('&' + filterStringWithEqualSign)
            }
        }

        sortValue = getOtherFilters(otherFilters, sortValue)

        return {
            sortValue: sortValue,
            className: className
        }
    }

    render() {
        const { filterId, active } = this.props
        const { sortValue, className } = this.getSortValue()
        const itemName = this.getItemName()

        return <FilterItem
            filterId={filterId}
            itemName={itemName}
            className={className}
            active={active}
            sortValue={sortValue}
        />
    }
}

const SecondaryFilter = ({filters, filterStrings, allItems, movies, queryStringValues, cinemaFrontPkType, translation}) => {
    return Object.keys(filters).map((filterId, index) => {
        const filter = filters[filterId]
        const { items } = filter

        if(!items || (filterId === "theatreName" && cinemaFrontPkType === MULTICINEMA) ) {
            return ''
        }

        const filterValues = useFilterValues(queryStringValues, filterId)
    
        // const filterValues = _.has(queryStringValues, filterId) ? Array.isArray(queryStringValues[filterId]) ? queryStringValues[filterId] : [queryStringValues[filterId]] : false
        const filterStringWithEqualSign = filterId + '='

        const filterItems = Object.keys(items).sort((a, b) => naturalCompare(items[a].name, items[b].name)).map((itemId, index) => {
            const item = items[itemId]
            if(!item) {
                return ''
            }
            
            item.id = itemId
            const hasItemsToDisplayOverall = _.intersection(item.movies, _.keys(movies))
            if(hasItemsToDisplayOverall.length === 0) {
                return ''
            }
            
            const itemsToDisplay = _.intersection(item.movies, allItems)
            const otherFilters = _.omit(filterStrings, filterId)
            const active = itemsToDisplay.length > 0 || (_.contains(_.keys(filterStrings), filterId) && _.keys(filterStrings).length <= 1)
            
            return <FilterItemContainer
                key={itemId}
                filterId={filterId}
                item={item}
                active={active}
                filterValues={filterValues}
                otherFilters={otherFilters}
                filterStringWithEqualSign={filterStringWithEqualSign}
                translation={translation}
            />
        })
        
        if(filterId === "technical") {
            const itemValues = _.values(items)
            const technicals = seperateAttributes(itemValues)

            return _.keys(technicals).map((key) => {
                return (
                    technicals[key].length > 0 && <ul key={key} className="filter-section">
                        {technicals[key].map((item) => {
                            const {id} = item
                            const hasItemsToDisplayOverall = _.intersection(item.movies, _.keys(movies))
                            if(hasItemsToDisplayOverall.length === 0) {
                                return ''
                            }

                            const itemsToDisplay = _.intersection(item.movies, allItems)
                            const otherFilters = _.omit(filterStrings, filterId)
                            const active = itemsToDisplay.length > 0 || (_.contains(_.keys(filterStrings), filterId) && _.keys(filterStrings).length <= 1)
                
                            return <FilterItemContainer
                                key={id}
                                filterId={filterId}
                                item={item}
                                active={active}
                                filterValues={filterValues}
                                otherFilters={otherFilters}
                                filterStringWithEqualSign={filterStringWithEqualSign}
                                translation={translation}
                            />
                        })}
                    </ul>
                )
            })
        } else {
            return (
                _.keys(items).length > 0 && <ul key={index} className="filter-section">
                    {filterItems}
                </ul>
            )
        }

    })
}


export default SecondaryFilter